<template>
  <div class="bone" id="mainPage">
    <div class="alignPDL">
      <div class="babe">
      </div>
      <div class="text">
        <h2>Займы до <span>100 000 ₽</span> <br />без кредитной истории</h2>
        <div id="uslovia">
          <div>
            <p>Нужен только паспорт!</p>
          </div>
<!--          <div>-->
<!--            <p>Первый заём</p>-->
<!--            <span>0%</span>-->
<!--          </div>-->
<!--          <span>На сумму до 30 тысяч рублей до 30 дней</span>-->
        </div>
        <div style="opacity: 0.7">Срок займа <b>до <span>1</span> года</b></div>
      </div>
      <uiProductAmountSelector
          v-on:scrollingTo="scrollingTo"
          :currentScreen="currentScreen"
      ></uiProductAmountSelector>
    </div>
  </div>
</template>

<script>
export default {
  name: "uiTitle",
  props: {
    currentScreen: {
      type: String,
      default: ''
    }
  },
  methods: {
    scrollingTo($event){
      this.$emit('scrollingTo',$event);
    }
    // navigationEmit($event) {
    //   this.$emit('scrollingTo', $event);
    // },
  },
  components: {
    uiProductAmountSelector: ()=>import('@/views/pdlloan/uiProductAmountSelector'),
  }
}
</script>

<style scoped>
h2 { color: #0D5740; font-family: 'Lato-Heavy'; font-size: 4.41vw; margin-bottom: 3.24vw  }
h2 > span { color: #0D5740; font-family: 'Lato-Heavy'; font-size: 5.88vw }
.babe { position: absolute; width: 45.59vw; height: 75.88vw; left: 54.18vw; top: -6.1vw; bottom: auto; background-image: url('../../../public/img/img_1_1.webp'); background-size: cover; z-index: 10;  }
/*.bone { background-color: #f3f4f6; background-image: url('../../../public/img/img_1_1.png'); background-repeat: no-repeat; background-position-x: 110%;background-position-y: 0; background-size: 48.27vw; padding: unset; height: 207.33vw }*/
.bone { background-color: #f3f4f6; padding: unset }
.bone > div { padding-top: 5.29vw; background-image: unset; box-sizing: border-box; position: relative; }
.bone > div > .text { padding: 4.12vw 4.12vw 2.65vw 4.12vw; background:  #FFF; border-radius: 11px; box-shadow: 0 0.59vw 4.41vw 0 rgba(0, 0, 0, 0.10); margin: 0 0 16.03vw 1.76vw; width: 57vw }
#uslovia {  }
#uslovia > div { display: flex; align-items: center; }
#uslovia > div > p { font-family: 'Lato-Heavy'; font-size: 4.41vw; color: #0D5740;}
#uslovia > div > span { border-radius: 16px; background: #4AAF3D; color: #FFFFFF; font-family: 'Lato-Heavy'; width: 15.88vw; height: 12.06vw; display: flex; align-items: center;
  justify-content: center; margin-left: 1.76vw; font-size: 7.65vw }
#uslovia > span { }
.bone > div > .text > div { font-weight: 500; color: rgba(19,21,21,.7019607843137254); font-size: 2.94vw }
.bone > div > .text > div:last-child { margin-bottom: 9.41vw }
.bone > div > .text > div > b > span { font-size: 9.12vw }
@media (min-width: 760px) {
  /*.bone { margin-bottom: 13.15vw  }*/
  .bone {  }
  .bone > div { padding-top: 3.84vw; display: flex; justify-content: space-between; align-items: flex-start; min-height: 68.23vw }
  .bone > div .text { width: 27.74vw; padding: 2.02vw 3.06vw; margin-top: 7vw; border-radius: 20px }
  #uslovia { margin-bottom: 0.53vw }
  #uslovia > div {  }
  #uslovia > div > p { font-size: 2.12vw }
  #uslovia > div > span { width: 8.23vw; height: 6.29vw; margin-left: 0.89vw; border-radius: 31px; font-size: 4.03vw }
  #uslovia > span { font-size: 1.45vw }
  .bone > div .text > div { padding: 0; font-size: 1.61vw }
  .bone > div .text > div:last-child { margin-bottom: 1.41vw; }
  .bone > div > .text > div > b > span { font-size: 4.84vw }
  h2 { margin-bottom: 3.05vw; font-size: 2.04vw }
  h2 > span { font-size: 2.85vw }
  .babe { width: 39.44vw; height: 68.23vw; left: 23.7vw; top: auto; bottom: 0}
}
@media (min-width: 1240px) {
  /*.bone { margin-bottom: 120px }*/
  .bone { }
  .bone > div { padding-top: 122px; min-height: 400px }
  .bone > div .text { width: 344px; padding: 25px 38px; margin-top: 68px; border-radius: 20px; margin-left: 0 }
  #uslovia { margin-bottom: 20px }
  #uslovia > div { margin-bottom: 8px }
  #uslovia > div > p { font-size: 30px }
  #uslovia > div > span { width: 103px; height: 78px; margin-left: 11px; font-size: 50px }
  #uslovia > span { font-size: 17px }
  .bone > div .text > div { padding: 0; font-size: 20px }
  .bone > div .text > div:last-child { margin-bottom: 1.41vw; }
  .bone > div > .text > div > b > span { font-size: 60px }
  h2 { margin-bottom: 22px; font-size: 29px }
  h2 > span { font-size: 39px }
  .babe { width: 489px; height: 846px; left: 292px; top: auto; bottom: 0}
}
</style>
